import CrAnalysisService from 'app/services/CrAnalysisService';
import BaseAnalysisFindPageMixin from 'app/mixins/BaseAnalysisFindPageMixin';

export default {
  mixins: [ BaseAnalysisFindPageMixin ],

  data() {
    return {
      service: CrAnalysisService,
      label: 'Analisi CR',
      filtersComponent: 'cr-analysis-filters',
      loadPage: 'CrAnalysis',
      clonePage: 'CrAnalysisClone',
    };
  },
}
